export default "__VITE_ASSET__$kY6Qf0S__"